import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'

type SkeletonBarProps = {
    width?: string | number
    minWidth?: string | number
    height?: string | number
    marginTop?: number
    marginLeft?: number
    borderRadius?: number
}

const SkeletonBar = ({
    width = '100%',
    minWidth = 0,
    height = 16,
    marginTop = 0,
    marginLeft = 0,
    borderRadius = 0,
}: SkeletonBarProps): ReactElement => {
    return (
        <Grid
            noExpand
            backgroundColor="moon-3"
            width={width}
            minWidth={minWidth}
            height={height}
            marginTop={marginTop}
            marginLeft={marginLeft}
            borderRadius={borderRadius}
        />
    )
}

export default memo(SkeletonBar)
